import { createMetaDef } from '@exodus/asset'

import tokensParams from './tokens.js'

const name = 'cronos'
const displayName = 'Cronos'
const ticker = 'CRONOS'
const displayTicker = 'CRO'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const primaryColor = '#1199FA'
const gradientColors = ['#1199FA', '#4FB6FF']
const gradientCoords = { x1: '0%', y1: '0%', x2: '100%', y2: '100%' }
const chainBadgeColors = gradientColors
const chainId = 25

const gasLimit = 21e3 // enough to send ETH to a normal address
const contractGasLimit = 1e6 // used when estimateGas fails

const units = {
  wei: 0,
  Kwei: 3,
  Mwei: 6,
  Gwei: 9,
  szabo: 12,
  finney: 15,
  [ticker]: 18,
}

const assetType = 'ETHEREUM_LIKE'
const tokenAssetType = 'CRC20'
const blockExplorer = {
  addressUrl: (address) => `https://cronoscan.com/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://cronoscan.com/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Cronos is the leading Ethereum-compatible layer 1 blockchain network built on the Cosmos SDK, supported by Crypto.com, Crypto.org and more than 400 app developers and partners.',
  website: 'https://cronos.org/',
  twitter: 'https://twitter.com/cronos_chain',
  telegram: 'https://t.me/Cronos_Announcements',
  discord: 'https://discord.com/invite/pahqHz26q4',
}

const assetParams = {
  assetType,
  blockExplorer,
  chainBadgeColors,
  chainId,
  contractGasLimit,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gasLimit,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  ticker,
  tokenAssetType,
  units,
}

const tokenOverrides = (token) => ({
  ...token,
  contract: token.addresses,
  gasLimit: 120e3,
})

export const { asset, tokens, assetsList } = createMetaDef({
  assetParams,
  tokensParams,
  tokenOverrides,
})

export default assetsList
